const signsOfForgottenGods = `

#### Trade Your Signs for Powerful Rewards
- You can trade **20 Signs of Forgotten Gods** with **Luciad Society Ruth** to receive **one of the following rewards**:

#### Possible Rewards:
- **Bellatrix's Sword**
- **Behemoth's Spear**
- **Rhegium's Outlaw**
- **Hermes's Hammer**
- **Lartis's Bow**
- **Lycan's Crossbow**
- **Branium's Staff**
- **Gladius**
- **Poison Dagger**
- **Strooder's Blessing**
- **Mark's Stick**
- **Demonic Axe**
- **Ring of Horadric**
- **Soul of Mortis**
- **Armor Upgrade**
- **Philosopher's Scroll**

#### How to Exchange
- Locate **Luciad Society Ruth** in the designated area.
- Ensure you have **20 Signs of Forgotten Gods** in your inventory.
- Initiate a trade to receive a **random reward** from the list above.

Good luck, and may the Forgotten Gods bless your journey! ⚔️`;

export default signsOfForgottenGods;
